export const SET_COUNTRY = 'app/SET_COUNTRY'
export const SET_CLIENT_TYPE = 'app/SET_CLIENT_TYPE'
export const SET_USER_TOKEN = 'app/SET_USER_TOKEN'

export const FEATURE_FLAGS = {
  CS_CONTACT_MY: 'csContactMY'
}
